function domain() {
  return window.location.origin + "/";
  // return "http://localhost:3000/";
  // return "https://shop.strackit.com/";
}

export default domain;
